export default __webpack_public_path__ + "static/media/WNo.7-5.13334aa1.jpg";